import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // We check for the same auth token your Nav.js uses
  const isAuthenticated = localStorage.getItem('authToken');
  const location = useLocation();

  if (!isAuthenticated) {
    // User is not authenticated.
    // Redirect them to the /login page, but save the location they were
    // trying to go to (e.g., "/checkout").
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, so we render the page they asked for.
  return children;
};

export default ProtectedRoute;
